import React from "react";
import ProductAssetImage from "./ProductAssetImage";

// Persist identities, never expiring S3 URLs. Legacy external photos still work.
export default function RecipeImage({ source, recipeId, config, alt, className = "", variant = "display", placeholder = "" }) {
  const assetId = String(source || "").startsWith("purchasing-asset:") ? source.slice(17) : null;
  return <span className={`recipe-image ${className}`}>{assetId
    ? <ProductAssetImage assetId={assetId} context={recipeId ? { recipe_id: recipeId } : {}} config={config} variant={variant} alt={alt} placeholder={placeholder} />
    : /^https?:\/\//i.test(source || "") ? <img src={source} alt={alt} loading="lazy" decoding="async" /> : placeholder}</span>;
}
